import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { PropAutoCompleteModel } from '../core/models/properties.model';
import { StepperService } from '../core/services/step-service/stepper.service';
import { mockTableProduct } from '../core/constants/properties-const';
import { PropertiesService } from './service/properties.service';
import { EnvironmentService } from '../core/enviroment/environment.service';

@Component({
  selector: 'app-properties',
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.scss']
})
export class PropertiesComponent implements OnInit {

  public active = false;
  public isDot = false;
  public openFilter = false;
  public showOpenDrop = false;
  public corp = false;
  public inCorp = false;
  public isFavorite = false;
  public isInput = false;
  public isDrag = true;
  public showModal = false;
  public loader = false;
  public textSearch = '';
  public text = '';
  public indexId = -1;
  public paramsRouter = null;
  public tags = [];
  public ListToService = [];
  public textField = null;
  public showPropRegistration = false;
  public listTable: any[] = [];
  public listTableOld = mockTableProduct;


  public listTemperature = [
    {id: 1, name: 'Quente', icon: 'hot'},
    {id: 2, name: 'Morno', icon: 'warm'},
    {id: 3, name: 'Frio', icon: 'cold'}
  ];

  public listChanger = [
    {id: 1, name: 'Verde', icon: 'dot-green'},
    {id: 2, name: 'Amarelo', icon: 'dot-yellow'},
    {id: 3, name: 'Vermelho', icon: 'dot-alert'}
  ];

  public regForm: FormGroup;
  public displayFilter = false;
  public displayList = false;
  public displayMap = false;
  public autocomp = false;
  public autocompIdx = -1;
  public autoSearchResults: PropAutoCompleteModel[] = [];
  public inputSearchValue = '';
  public featureInputSearch = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private stepperService: StepperService,
    private service: PropertiesService,
    private environmentService: EnvironmentService
  ) { }

  ngOnInit() {
    this.featureInputSearch = this.environmentService.getEnvVar('feature_input_search') === 'true';
    this.initForm();
    this.positionStorage();
  }

  public positionStorage() {
    if (localStorage.getItem('position-properties') === 'table-properties') {
      this.displayList = true;
    } else {
      this.displayList = false;
    }
  }

  public initForm() {
    this.regForm = this.fb.group({
      searchTerm: [null],
      temp: [null],
      late: [null],
      isFavorite: [null],
      corporator: [null],
      notCorporator: [null],
      archived: [null]
    });
  }

  public validatorDot(): boolean {
    if (this.regForm.get('temp').value ||
      this.regForm.get('late').value ||
      this.regForm.get('isFavorite').value ||
      this.regForm.get('corporator').value ||
      this.regForm.get('notCorporator').value) {
        this.isDot = true;
    } else {
      this.isDot = false;
    }
    return this.isDot;
  }

  public changeStructure() {
    this.displayList = !this.displayList;
    if (this.displayList) {
      localStorage.setItem('position-properties', 'table-properties');
    } else {
      localStorage.setItem('position-properties', 'properties');
    }
  }

  public changeTempData(event) {
    this.regForm.get('temp').setValue(event.name);
  }

  public changeDataLate(event) {
    this.regForm.get('late').setValue(event.name);
  }

  public selectField(data: string) {
    this.isFavorite = !this.isFavorite;
    this.regForm.get(data).setValue(this.isFavorite);
  }

  public selectIncorporator() {
    this.corp = !this.corp;
    this.inCorp = false;
    this.regForm.get('corporator').setValue(this.corp);
    this.regForm.get('notCorporator').setValue(this.inCorp);
  }

  public selectNotCorp() {
    this.inCorp = !this.inCorp;
    this.corp = false;
    this.regForm.get('corporator').setValue(this.corp);
    this.regForm.get('notCorporator').setValue(this.inCorp);
  }

  public resetForm() {
    this.regForm.reset();
  }

  public initFormRouter() {
    this.router.navigate([`/facs`], { queryParams: {
      temperatura: this.regForm.get('temp').value,
      vencimentos: this.regForm.get('late').value,
      favoritos: this.regForm.get('isFavorite').value ? this.regForm.get('isFavorite').value : null,
      incorporador: 'Foi borracha',
      arquivados: this.regForm.get('archived').value ? this.regForm.get('archived').value : null
    }});
  }

  public registerNewProp() {
    this.showPropRegistration = true;
  }

  public closeProductRegistration() {
    this.showPropRegistration = false;
  }

  public close() {
    this.isInput = false;
  }

  public showFilter() {
    this.displayFilter = !this.displayFilter;
  }

  public showMap(): void {
    this.displayMap = !this.displayMap;
  }

  public pointerSelection(idx: number): void {
    this.autocompIdx = idx;
  }

  public downList(event): void {
    if ((event.keyCode === 40 || event.keyCode === 38 || event.keyCode === 27)) {
      switch (event.keyCode) {
        case 40:
          if (this.autocompIdx < this.autoSearchResults.length - 1) {
            this.autocompIdx += 1;
          }
          break;
        case 38:
          if (this.autocompIdx > 0) {
            this.autocompIdx -= 1;
          }
          break;
        case 27:
          this.autocomp = false;
          this.autocompIdx = -1;
          return;
      }
      this.updateSearchInput();
    }
  }

  public patchInputValue(item): void {
    this.autocomp = false;
    this.updateSearchInput();
    this.tags = []; // REMOVER QUANDO HABILITAREM MULTIPLAS TAGS
    this.tags.push({
      id: item.result.description,
      name: item.result.label,
      description: item.result.label,      
      value: item.result.value,
      label: item.result.label,
      type: item.result.labelDescription,
      tag: item.result.tag
    });
    this.service.getProducts({value: item.result.id, type: item.result.tag}).subscribe(response => {
      this.listTable = response;
    })
    this.autocompIdx = -1;
  }

  public updateSearchInput(): void {
    this.regForm.get('searchTerm').setValue('');
  }

  public searchInput(event: string | number): void {
    const searchTxt = String(event);
    if (searchTxt.trim().length > 2) {
      this.autoSearchResults = [];
      this.service.autoComplete(searchTxt).subscribe(response => {
        this.autoSearchResults = response.content;
      });
      this.autocomp = true;
    } else {
      this.autocomp = false;
      this.autocompIdx = -1;
    }
  }

  public removeTags(data: string, index: number) {
    this.tags.splice(index, 1);
    this.listTable = []; // REMOVER QUANDO HABILITAREM MULTIPLAS TAGS
  }

  public registryRouter() {
    this.router.navigate(['registro'], { relativeTo: this.route });
  }

  public closeMOdal(event) {
    this.active = event;
  }

}
